import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcAddFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.75 20v-6.75H4a1.25 1.25 0 1 1 0-2.5h6.75V4a1.25 1.25 0 1 1 2.5 0v6.75H20a1.25 1.25 0 1 1 0 2.5h-6.75V20a1.25 1.25 0 1 1-2.5 0"
  }));
}
var IcAddFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAddFill));

export { IcAddFill as I };
